import axiosInstance from '@/plugins/axios';

// Dashboard CBO (Classificação Brasileira de Ocupações) — porte do TrabalhadorCboService (BFF).
const BASE = 'collaborator/history/cbo-analysis';

const ServiceCBO = {
  dashboardStep: (body) => axiosInstance.post(`${BASE}/dashboard/step`, body ?? {}),
  dashboardStatus: (body) => axiosInstance.post(`${BASE}/dashboard/status`, body ?? {}),
  dashboardClassification: (body) =>
    axiosInstance.post(`${BASE}/dashboard/classification`, body ?? {}),
  dashboardRisk: (body) => axiosInstance.post(`${BASE}/dashboard/risk`, body ?? {}),
  /**
   * @param {*} body
   * @param {{ page?: number, size?: number, sort?: string }} [opts]
   **/
  history: (body, { page = 0, size = 50, sort } = {}) =>
    axiosInstance.post(BASE, body ?? {}, { params: { page, size, ...(sort ? { sort } : {}) } }),
  // Opções de filtro (CON-4199): valores distintos existentes no banco, por CNPJ-raiz.
  filters: (rootCnpjList) => axiosInstance.post(`${BASE}/filtros`, rootCnpjList ?? null),
  // Aba Pesquisa: busca CBO por descrição das atividades. body = { query, page, size }.
  search: (body) => axiosInstance.post('collaborator/cbo', body ?? {}),
  // CON-5197: autocomplete de ocupação no modal de análise. body = { title }.
  searchOccupations: (body, { page = 0, size = 20 } = {}) =>
    axiosInstance.post('cbo/list', body ?? {}, { params: { page, size } }),
  // CON-5197: ocorrências (config de risco) para o select do modal de análise.
  listRiskOccurrences: (body, { page = 0, size = 500 } = {}) =>
    axiosInstance.post('cbo-analysis/config/risk-classification/list', body ?? {}, {
      params: { page, size },
    }),
  // Exportações: enfileiram um export persistido (report_process) — não retornam mais binário.
  exportHistory: (body) => axiosInstance.post(`${BASE}/export`, body ?? {}),
  // Visão do cliente: mesmo filtro, subset de colunas (esconde etapa/status/diagnóstico).
  exportHistoryClientView: (body) => axiosInstance.post(`${BASE}/export/client-view`, body ?? {}),
  // Exportação da aba Pesquisa (busca CBO por descrição). body = { query }.
  exportSearch: (body) => axiosInstance.post('collaborator/cbo/export', body ?? {}),

  // Análise do analista (Fase 2) — GET/edit/histórico por trabalhador.
  // O BFF (fiel ao Java) expõe GET para carregar a análise.
  getAnalysis: (trabalhadorId) => axiosInstance.get(`collaborator/${trabalhadorId}/cbo/analysis`),
  updateAnalysis: (trabalhadorId, body) =>
    axiosInstance.post(`collaborator/${trabalhadorId}/cbo/analysis`, body ?? {}),
  getHistory: (trabalhadorId, cboAnalysisId, { page = 0, size = 50 } = {}) =>
    axiosInstance.post(
      `collaborator/${trabalhadorId}/cbo/analysis/${cboAnalysisId}/history`,
      {},
      { params: { page, size } },
    ),

  // Informações adicionais da análise CBO (CON-4206) — texto + anexo opcional, só analista.
  informacaoAdicionalBase: (trabalhadorId, cboAnalysisId) =>
    `collaborator/${trabalhadorId}/cbo/analysis/${cboAnalysisId}/informacoes-adicionais`,

  listInformacoesAdicionais: (trabalhadorId, cboAnalysisId) =>
    axiosInstance.get(ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId)),

  criarInformacaoAdicional: (trabalhadorId, cboAnalysisId, { texto, file }) => {
    const fd = new FormData();
    fd.append('texto', texto);
    if (file) fd.append('file', file);
    return axiosInstance.post(ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId), fd);
  },

  editarInformacaoAdicional: (
    trabalhadorId,
    cboAnalysisId,
    id,
    { texto, justificativa, file, removerAnexo },
  ) => {
    const fd = new FormData();
    fd.append('texto', texto);
    fd.append('justificativa', justificativa);
    if (removerAnexo) fd.append('removerAnexo', 'true');
    if (file) fd.append('file', file);
    return axiosInstance.patch(
      `${ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId)}/${id}`,
      fd,
    );
  },

  excluirInformacaoAdicional: (trabalhadorId, cboAnalysisId, id) =>
    axiosInstance.delete(
      `${ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId)}/${id}`,
    ),

  historicoInformacoesAdicionais: (trabalhadorId, cboAnalysisId) =>
    axiosInstance.get(
      `${ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId)}/history`,
    ),

  downloadUrlInformacaoAdicional: (trabalhadorId, cboAnalysisId, id) =>
    axiosInstance.get(
      `${ServiceCBO.informacaoAdicionalBase(trabalhadorId, cboAnalysisId)}/${id}/download-url`,
    ),
};

export default ServiceCBO;
